import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsButtonImpression,
    getGoogleAnalyticsButtonImpression
} from "./GoogleAnalyticsButtonImpression";

export interface GoogleAnalyticsButtonClick
    extends GoogleAnalyticsButtonImpression {}

const getGoogleAnalyticsButtonClick = (
    data: TypedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsButtonClick => {
    return getGoogleAnalyticsButtonImpression(
        data,
        GoogleAnalyticsEvents.ButtonClick
    );
};

export { getGoogleAnalyticsButtonClick };
